import { indexBoard } from "@/mocks/home";

export default function IndexBoard() {
  return (
    <section id="index" className="w-full bg-background-100 border-y border-foreground-950/10">
      <div className="w-full px-4 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4 lg:sticky lg:top-28 self-start">
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">CONTENTS</p>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              本期导读
            </h2>
            <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
              把"入口在哪、怎么看"拆成五个能直接执行的条目。第一次来按顺序读一遍，
              基本就不会再出现找不到入口的情况。
            </p>
            <a
              href="#guide"
              className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              直接跳到使用攻略
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>

          <div className="lg:col-span-8">
            <ul className="divide-y divide-foreground-950/12 border-t border-foreground-950/12">
              {indexBoard.map((item) => (
                <li key={item.no} className="group">
                  <a
                    href="#ways"
                    className="flex gap-4 md:gap-6 py-5 md:py-6 cursor-pointer"
                  >
                    <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-300 group-hover:text-primary-500 transition-colors w-12 md:w-16 shrink-0">
                      {item.no}
                    </span>
                    <span className="flex-1">
                      <span className="flex flex-wrap items-center gap-3">
                        <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                          {item.title}
                        </span>
                        <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap">
                          {item.tag}
                        </span>
                      </span>
                      <span className="mt-2 block text-sm leading-6 text-foreground-600">
                        {item.summary}
                      </span>
                    </span>
                    <span className="hidden md:flex w-9 h-9 shrink-0 items-center justify-center rounded-full border border-foreground-950/15 text-foreground-500 group-hover:border-primary-400 group-hover:text-primary-600 transition-colors">
                      <i className="ri-arrow-right-up-line"></i>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}